import { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  StackRequestsTable,
  AssignedStacksTable,
  DeliveredStacksTable,
  AllStacksTable
} from "../components/tables/StacksTables";
import {
  loadAssignedStacks,
  loadStackRequests,
  assignStackRequest,
  unassignStack,
  deleteStack,
  loadDeliveredStacks,
  submitStack,
  closeStack,
  downloadStackAttachment,
  downloadAttachment,
  createStackRequest,
  loadAllNotAnsweredStacks,
  loadAllStacks,
  loadClosedStacks,
  joinStacks
} from "../store/app/app.slice";
import {useHistory, useParams,} from "react-router-dom";
import {Alert, message, notification} from "antd";
import {StackRequestDto} from "ps-letter-mgmtrest-client";
import {StackDto} from "ps-letter-mgmtrest-client";
import CreateRequestStackDialog from "../components/dialogs/CreateRequestStackDialog";
import {CreateStackRequestDto} from "ps-letter-mgmtrest-client";


function StacksOverview({archive}) {

  const dispatch = useDispatch();
  const params = useParams();
  const { stackRequests, assignedStacks, deliveredStacks, allStacks, notAnsweredStacks, closedStacks } = useSelector((state) => state.app);
  const currentStackType = params?.stackType?.toUpperCase()
  const history = useHistory();
  const [openStackRequestDialog, setOpenStackRequestDialog] = useState(false);
  const [pdfGenerating, setPdfGenerating] = useState(false);
  const showModal = () => {
    setOpenStackRequestDialog(true);
  };

  const hideModal = () =>  {
    setOpenStackRequestDialog(false);
  }
  
  const navigateToStackDetailsView = (record) => {

    if(currentStackType !== undefined && currentStackType !== null)
    {
      history.push("/process/"+params?.stackType+"/stacks/"+record.id)  
    }else{
      history.push("/stacks/"+record.id) // stacks/:stackid
    }
    
  }

  const fetchData = () => {
    if(archive === true){
      dispatch(loadAllStacks({}));  
    }else{
      dispatch(loadStackRequests({}));
      dispatch(loadAssignedStacks({}));
      dispatch(loadDeliveredStacks({}));
      dispatch(loadClosedStacks({}));

      if(currentStackType === "ANSWER") {
        dispatch(loadAllNotAnsweredStacks({}));  
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [params?.stackType]);
  
  const handleRemoveRequest = (record) => {
    dispatch(deleteStack({
      finalData: {id: record.id},
      callbackSuccess: (response) => {
        console.log("Stack deleted successfully", response);
        fetchData();
        message.success("Stack deleted successfully")
      },
      callbackError: (error) => {
        console.error("Error deleting stack", error);
        message.error({content: error})
      }
    }))
  };
  
  const handleUnassignRequest = (record) => {
    dispatch(unassignStack({
      finalData: {stackId: record.id},
      callbackSuccess: (response) => {
        console.log("Stack unassigned successfully", response);
        fetchData();
        message.success("Stack unassigned successfully")
      },
      callbackError: (error) => {
        console.error("Error unassigning stack", error);
        message.error({content: error})
      }
    }));
  };

  const handleSubmitStack = (record) => {
    dispatch(submitStack({
      finalData: {stackId: record.id},
      callbackSuccess: (response) => {
        console.log("Stack submitted successfully", response);
        notification['success']({
          message: 'Stack submitted',
          description:
              'Stack #'+record.id+' has been submitted.',
        });
        fetchData();
      },
      callbackError: (error) => {
        console.error("Error closing stack", error);
        notification['error']({
          message: 'Error closing stack',
          description:error,
        });
      }
    }));
  };

  const handleLinkedStackRequest = (record) =>  {
    
    const stackRequest : CreateStackRequestDto = {
      requestedStackType: "ANSWER",
      requestedLanguages: record.requestedLanguages,
      requestedAmount: record.assignedAmount,
      linkedStack: record
    }
    dispatch(createStackRequest({
      finalData: {
        requestedStack: stackRequest
      },
      callbackSuccess: (response: StackDto) => {
        console.log("Stack requested successfully", response);
        
        if(response.status === "ASSIGNED")
        {
          notification['success']({
            message: 'Answer Stack assigned',
            description:
                'Stack #'+response.id+' created.',
          });  
        }else{
          notification['warn']({
            message: 'Answer Stack requested',
            description:
                'Stack Request #'+response.id+' created.',
          });
        }
        fetchData();
      },
      callbackError: (error) => {
        console.error("Error creating stack", error);
        notification['error']({
          message: 'Error creating stack',
          description:error,
        });
      }
    }));
  }
  
  const handleJoinStacks = (stackIds, onSuccess) => {
    dispatch(joinStacks({
      finalData: {stackIds: stackIds},
      callbackSuccess: (response) => {
        console.log("Stacks joined successfully", response);
        notification['success']({
          message: 'Stacks joined',
          description:
              stackIds.length + ' stacks have been joined into Stack #' + response.id + ' with ' + response.assignedAmount + ' letters.',
        });
        if (typeof onSuccess === 'function')
          onSuccess();
        fetchData();
      },
      callbackError: (error) => {
        console.error("Error joining stacks", error);
        notification['error']({
          message: 'Error joining stacks',
          description: error,
        });
      }
    }));
  };

  const handleCloseStack = (record) => {
    dispatch(closeStack({
      finalData: {stackId: record.id},
      callbackSuccess: (response) => {
        console.log("Stack closed successfully", response);
        notification['success']({
          message: 'Stack closed',
          description:
              'Stack #'+record.id+' has been closed.',
        });
        fetchData();
      },
      callbackError: (error) => {
        console.error("Error closing stack", error);
        notification['error']({
          message: 'Error closing stack',
          description:error,
        });
      }
    }));
  };

  const handleDownloadStackAttachment = (record, deliveryMethod) => {
    dispatch(downloadStackAttachment({
      finalData: {stackId: record.id, deliveryMethod: deliveryMethod},
      callbackSuccess: (response) => {
        console.log("Download started", response);
        notification['success']({
          message: 'Download started',
          description:
              'Stack #'+record.id+' attachment download started.',
        });
      },
      callbackError: (error) => {
        console.error("Error downloading stack attachments", error);
        notification['error']({
          message: 'Error downloading stack ',
          description:error,
        });
      }
    }));
  };

  const handleDownloadStackPdfs = (record) => {
    if (!record?.attachmentIdMailDeliveryPdf) {
      notification['error']({
        message: 'No stack PDFs available',
        description: 'Stack #'+record.id+' has no merged answer PDF yet. Submit the review stack first.',
      });
      return;
    }
    setPdfGenerating(true);
    dispatch(downloadAttachment({
      finalData: {id: record.attachmentIdMailDeliveryPdf},
      callbackSuccess: () => {
        setPdfGenerating(false);
        notification['success']({
          message: 'PDF Download Complete',
          description:
              'Stack #'+record.id+' PDF download complete.',
        });
      },
      callbackError: (error) => {
        setPdfGenerating(false);
        console.error("Error downloading stack PDFs", error);
        notification['error']({
          message: 'Error downloading stack PDFs',
          description:error,
        });
      }
    }));
  };
  
  const handleConfirmRequest = (data) => {
    //Reshape the data and send request using dispatch
    const requestData = {
      assignedStack: {
        id: data.id,
        assigneeId: data.requesterId,
        assigneeName: data.requesterName,
        assignedAmount: data.editedAmount,
        assignedLanguages: data.requestedLanguages ? data.requestedLanguages.filter(lang => lang != null) : [],
        assignmentType: data.assignmentType,
        assignedStackType: data.requestedStackType
      }
    }
    dispatch(assignStackRequest({
      finalData: requestData,
      callbackSuccess: (response) => {
        console.log("Stack request assigned successfully", response);
        fetchData();
        message.success("Stack assigned successfully")
      },
      callbackError: (error) => {
        console.error("Error assigning stack request", error);
        message.error({content: error})
      }
    }));
    console.log("Confirm Request Handler", data);
  };
  
  if(archive)
  {
    return <div>
          <AllStacksTable
              key={currentStackType+"allStacksTable"}
              stacks={allStacks}
              navigateToStackDetailsView={navigateToStackDetailsView}
              title={"Stacks Archive"}
              showReferencedStack={true}
          /> 
    </div>
  }else{
    return (
        <div>
          {"FILTRATION" === currentStackType ?
              <Alert
                  style={{marginBottom: 24}}
                  type="info"
                  showIcon
                  message="Filtration is being phased out"
                  description="New filtration stacks can no longer be started. New letters are now assigned directly to summary stacks. Please finish the filtration stacks that are still open."
              /> : ""}

          {"SUMMARY" === currentStackType || undefined === currentStackType ?
              <StackRequestsTable
                  key={currentStackType+"stackRequestsTable"}
                  stackRequests={stackRequests.filter((stack: StackRequestDto) => currentStackType === undefined || currentStackType === stack.requestedStackType).reverse()}
                  handleRemoveRequest={handleRemoveRequest}
                  handleConfirmRequest={handleConfirmRequest}
                  showNewStackRequestModal={currentStackType === "SUMMARY" ? showModal : undefined}
                  showNewStackRequestTitle={currentStackType === "SUMMARY" ? "Request Summary Stack" : undefined}
                  title={currentStackType === "SUMMARY" ? "Requested Summary Stacks" : "Requested Stacks"}
                  stackType={currentStackType}
                  navigateToStackDetailsView={navigateToStackDetailsView}
              /> : ""}

          {"ANSWER" === currentStackType ?
              <DeliveredStacksTable
                  key={currentStackType+"deliveredSummaryStacksTable"}
                  assignedStacks={notAnsweredStacks.filter((stack: StackDto) => "SUMMARY" === stack.assignedStackType && !stack.referencedStackId).reverse()}
                  navigateToStackDetailsView={navigateToStackDetailsView}
                  handleSubmitStack={handleSubmitStack}
                  handleCloseStack={handleCloseStack}
                  handleDownloadStackAttachment={handleDownloadStackAttachment}
                  handleDownloadStackPdfs={handleDownloadStackPdfs}
                  pdfGenerating={pdfGenerating}
                  fetchData={fetchData}
                  title={"Summaries ready for Answering"}
                  stackType={"SUMMARY"}
                  areNotAnsweredStacks={true}
                  handleLinkedStackRequest={handleLinkedStackRequest}
              /> : ""}

          {"ANSWER" === currentStackType ?
              <StackRequestsTable
                  key={currentStackType+"stackRequestsTable"}
                  stackRequests={stackRequests.filter((stack: StackRequestDto) => "ANSWER" === stack.requestedStackType).reverse()}
                  handleRemoveRequest={handleRemoveRequest}
                  handleConfirmRequest={handleConfirmRequest}
                  title={"Requested Answer Stacks"}
                  stackType={currentStackType}
                  showReferencedStack={true}
                  navigateToStackDetailsView={navigateToStackDetailsView}
              /> : ""}

          {"REVIEW" === currentStackType ?
              <AssignedStacksTable
                  key={"REVIEW_ANSWER_assignedReviewTable"}
                  assignedStacks={assignedStacks.filter((stack: StackDto) => "REVIEW_ANSWER" === stack.assignedStackType).reverse()}
                  navigateToStackDetailsView={navigateToStackDetailsView}
                  handleUnassignRequest={handleUnassignRequest}
                  fetchData={fetchData}
                  title={"Review Answers"}
                  stackType={"REVIEW_ANSWER"}
                  showReferencedStack={true}
              /> : ""}

          {"REVIEW" === currentStackType ?
              <DeliveredStacksTable
                  key={"REVIEW_ANSWER_submittedReviewTable"}
                  assignedStacks={[...deliveredStacks.filter((stack: StackDto) => "REVIEW_ANSWER" === stack.assignedStackType).reverse(), ...closedStacks.filter((stack: StackDto) => "REVIEW_ANSWER" === stack.assignedStackType).reverse()]}
                  navigateToStackDetailsView={navigateToStackDetailsView}
                  handleSubmitStack={handleSubmitStack}
                  handleCloseStack={handleCloseStack}
                  handleDownloadStackAttachment={handleDownloadStackAttachment}
                  handleDownloadStackPdfs={handleDownloadStackPdfs}
                  pdfGenerating={pdfGenerating}
                  fetchData={fetchData}
                  title={"Submitted Review Stacks"}
                  stackType={"REVIEW_ANSWER"}
                  showReferencedStack={true}
              /> : ""}

          {"REVIEW" !== currentStackType ?
          <AssignedStacksTable
              key={currentStackType+"assignedStacksTable"}
              assignedStacks={assignedStacks.filter((stack: StackDto) => currentStackType === undefined || currentStackType === stack.assignedStackType).reverse()}
              navigateToStackDetailsView={navigateToStackDetailsView}
              handleUnassignRequest={handleUnassignRequest}
              fetchData={fetchData}
              title={currentStackType === "FILTRATION" ? "In Filtration" : currentStackType === "SUMMARY" ? "Creating Summaries" : currentStackType === "ANSWER" ? "Writing Answers" : "Assigned Stacks"}
              stackType={currentStackType}
              showReferencedStack={currentStackType === "ANSWER"}
              handleJoinStacks={currentStackType === "SUMMARY" ? handleJoinStacks : undefined}
          /> : ""}

          {"REVIEW" !== currentStackType ?
          <DeliveredStacksTable
              key={currentStackType+"deliveredStacksTable"}
              assignedStacks={[...deliveredStacks.filter((stack: StackDto) => currentStackType === undefined || currentStackType === stack.assignedStackType).reverse(), ...closedStacks.filter((stack: StackDto) => currentStackType === undefined || currentStackType === stack.assignedStackType).reverse()]}
              navigateToStackDetailsView={navigateToStackDetailsView}
              handleSubmitStack={handleSubmitStack}
              handleCloseStack={handleCloseStack}
              handleDownloadStackAttachment={handleDownloadStackAttachment}
              handleDownloadStackPdfs={handleDownloadStackPdfs}
              pdfGenerating={pdfGenerating}
              fetchData={fetchData}
              title={currentStackType === "FILTRATION" ? "Filtered Stacks" : currentStackType === "SUMMARY" ? "Printed Summaries" : currentStackType === "ANSWER" ? "Printed Answers" : "Delivered Stacks"}
              stackType={currentStackType}
              showReferencedStack={currentStackType === "ANSWER"}
          /> : ""}

          <CreateRequestStackDialog showModal={openStackRequestDialog} onHideModal={hideModal} fetchData={fetchData}/>

        </div>

    );
  }
}

export default StacksOverview;
